import { Box, Button, Icon, Typography } from "@outschool/backpack";
import { faEye, faPaperclip } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { useSession } from "@outschool/ui-auth";
import { useCopyLinkToClipboard } from "@outschool/ui-components-website";
import React from "react";

import { websiteRoutes } from "../../../../shared/Routes";
import { PrivacyStateSelect } from "../../account/PrivacyStateSelect";

export function ProfileLinkSelect({
  isCurrentUsersProfile,
  publicLink,
  publicLinkNoPreview,
  privateLinkNoPreview,
  privacyState,
}: {
  isCurrentUsersProfile: boolean;
  publicLink: string;
  publicLinkNoPreview: string;
  privateLinkNoPreview: string;
  privacyState: string | null | undefined;
}) {
  const { isLoggedIn, currentUser } = useSession();
  const { t } = useTranslation("client\\routes\\ParentProfile");
  const { wasCopied, onCopy } = useCopyLinkToClipboard();

  const appropriateLink =
    privacyState === "private link"
      ? privateLinkNoPreview
      : publicLinkNoPreview;
  const copyLinkButtonText =
    privacyState === "private link"
      ? t("Copy Private Link")
      : t("Copy Profile Link");

  const handleClick = async () => {
    const fullUrl = websiteRoutes.baseUrl + appropriateLink;
    await onCopy(fullUrl);
  };

  if (
    !isLoggedIn ||
    !isCurrentUsersProfile ||
    !currentUser ||
    !currentUser.privacy_state
  ) {
    return null;
  }

  return (
    <Box>
      <Typography
        emphasized
        as="label"
        htmlFor="profileVisibilitySelect"
        sx={{ textAlign: "center", marginBottom: "0.5rem" }}
      >
        {t("Who can see my full profile?")}
      </Typography>
      <PrivacyStateSelect />

      <Button
        color="inherit"
        fullWidth
        size="small"
        sx={{ mt: "1rem", fontSize: "1.3rem" }}
        startIcon={<Icon icon={faPaperclip} />}
        onClick={handleClick}
        disabled={privacyState === "only me"}
      >
        {wasCopied ? t("Copied!") : copyLinkButtonText}
      </Button>

      <Button
        color="inherit"
        fullWidth
        size="small"
        sx={{ mt: "0.25rem", fontSize: "1.3rem" }}
        startIcon={<Icon icon={faEye} />}
        onClick={() => window.open(publicLink, "_blank")}
      >
        {t("View Public Profile")}
      </Button>
    </Box>
  );
}
